import { render, staticRenderFns } from "./PlaylistsMain.vue?vue&type=template&id=5bc76091&scoped=true"
import script from "./PlaylistsMain.vue?vue&type=script&lang=ts"
export * from "./PlaylistsMain.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc76091",
  null
  
)

export default component.exports